import { BookedState } from 'components/VenueTile/VenueCard';

export enum VenueStatus {
    // Inquiry Statuses
    Added = 'Added',
    Queued = 'Queued',
    Submitted = 'Submitted',
    InquiryRejected = 'Inquiry Rejected',
    InquiryCancelled = 'Inquiry Cancelled',

    // Proposal Statuses
    ProposalReceived = 'Proposal Received',
    ProposalRejected = 'Proposal Rejected',
    ProposalCancelled = 'Proposal Cancelled',
    ExtensionPending = 'Extension Pending',
    ExtensionRejected = 'Extension Rejected',
    ProposalExpired = 'Proposal Expired',
    ContractPending = 'Contract Pending',
    Booked = 'Booked',
    BookingCancelled = 'Booking Cancelled',
}

export enum TabLabels {
    ALL = 'All',
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
    QUEUED = 'Queued',
}

export const PROPOSAL_INQUIRY_STATUS = new Set<BookedState>([
    'Proposal Received',
    'Contract Pending',
    'Booked',
    'Submitted',
]);

export const INQUIRY_CANCELLED_OR_EXPIRED = new Set<BookedState>([
    'Inquiry Rejected',
    'Inquiry Cancelled',
    'Proposal Cancelled',
    'Proposal Rejected',
    'Proposal Expired',
    'Extension Pending',
    'Extension Rejected',
]);

/** Statuses that occupy a shortlist slot (excludes Queued and rejected/cancelled). Includes Proposal Expired, ExtensionPending, and ContractPending. */
export const SHORTLIST_STATUSES = new Set<VenueStatus>([
    VenueStatus.Added,
    VenueStatus.Submitted,
    VenueStatus.ProposalReceived,
    VenueStatus.ExtensionPending,
    VenueStatus.ProposalExpired,
    VenueStatus.ContractPending,
    VenueStatus.Booked,
]);

export const INQUIRY_REJECTED_OR_CANCELLED = new Set<BookedState>([
    VenueStatus.ProposalRejected,
    VenueStatus.InquiryRejected,
    VenueStatus.InquiryCancelled,
    VenueStatus.ProposalCancelled,
    VenueStatus.BookingCancelled,
    VenueStatus.ExtensionRejected,
]);

export const INQUIRY_REJECTED_STATUS = new Set<BookedState>([
    VenueStatus.ProposalRejected,
    VenueStatus.InquiryRejected,
    VenueStatus.ExtensionRejected,
    VenueStatus.ProposalCancelled,
    VenueStatus.BookingCancelled,
]);

export const HAS_PROPOSAL_STATUS = new Set<BookedState>([
    VenueStatus.ProposalReceived,
    VenueStatus.ProposalExpired,
    VenueStatus.ExtensionPending,
    VenueStatus.ExtensionRejected,
    VenueStatus.ProposalRejected,
    VenueStatus.ProposalCancelled,
    VenueStatus.ContractPending,
    VenueStatus.Booked,
    VenueStatus.BookingCancelled,
]);

/** Statuses where an inquiry has been submitted (proposal statuses + Submitted). */
export const HAS_MESSAGES_ENABLED_STATUS = new Set<BookedState>([...HAS_PROPOSAL_STATUS, VenueStatus.Submitted]);

export const HAS_ACCEPTED_PROPOSAL_STATUS = new Set<BookedState>([
    VenueStatus.ContractPending,
    VenueStatus.Booked,
    VenueStatus.BookingCancelled,
]);

export enum ProposalStatus {
    ACCEPTED = 'Accepted',
    REJECTED = 'Rejected',
    PENDING = 'Pending',
    EXPIRED = 'Expired',
}

export enum CONTRACT_AND_PAYMENT_STEPS {
    DOWNLOAD_DOCUMENTS = 'download_documents',
    COMPLETE_SIGN_DOCUMENTS = 'complete_sign_documents',
    UPLOAD_SIGNED_DOCUMENTS = 'upload_signed_documents',
    PAYMENT_DETAILS = 'payment_details',
    FINALIZE_DETAILS = 'finalize_details',
}
